import React from "react";
import PageHeader from "../PageHeader"; // Import the component
import AboutUsSection from "../About"; // Your existing About Section
import heroBackImage from "../images/aboutus/about.webp"; // Import the background image you want
import Faqs from "../Faqs";
const AboutPage = () => {
  
  // 1. Define the breadcrumb path
  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "من نحن", path: "/about" } // The last one is the active page
  ];

  return (
    <>
      {/* 2. Use the Component */}
      <PageHeader 
        title="من نحن" 
        bgImage={heroBackImage} 
        breadcrumbs={breadcrumbLinks} 
      />

      {/* The rest of your page content */}
      <AboutUsSection />
      <Faqs />
    </>
  );
};

export default AboutPage;